import React from 'react';
import './App.css';
import {Provider} from 'react-redux';
import createStore from './store';
import {setupUserManager} from 'features/auth/userManager';
import {UserManager} from 'oidc-client';
import {OidcProvider} from 'redux-oidc';
import Routes from './components/Routes';

type State = {
  userManager: UserManager | null
};

const store = createStore({}); // todo: preloadedState

export default class App extends React.Component<{}, State> {
  readonly state: State = {
     userManager: null
  };
  
  async componentDidMount() {
    if (!this.state.userManager) {
      const userManager = await setupUserManager(store);
      this.setState({userManager});
    }
  }

  render() {
    const { userManager } = this.state;
    if (!userManager)
      return <div>Loading...</div>;
    
    return <Provider store={store}>
      <OidcProvider store={store} userManager={userManager}>
        <Routes />
      </OidcProvider>
    </Provider>;
  }
}


